import React , {useState} from "react";
import { useSelector } from "react-redux";

import { queryClient } from '../../state/queryClient';
import { useAllContrats } from "../../state/reactquery";
import { addEltHistory } from "../../state/reactquery";


import { axios_contrats_updatecontrat } from "../../axios/axios_contrats";

import Boulettes from "../../Components/ContratWin/Boulettes";
import ButtonSimple from "../../Components/Buttons/ButtonSimple";

import { jsonstatutscontrats } from "../../utils/utils_contratwin";


import croixclose from '../../images/croixclose.svg';



import './PopupReassigner.scss' ;




function PopupChangeStatutContrat({setShowpopupchangestatut,listidchangestatut,setListidchange ,dates}){
    const {date1,date2} = useSelector(state=>state.gestioncontrats);
    const {data:contrats}  = useAllContrats(date1,date2) ; 

    const [etape, setEtape] = useState(1) ;
    const [newstatus, setNewstatus] = useState(null) ;

    const requalification=async () =>{
       // DEV
        const listeidleads = contrats.filter(x=>listidchangestatut.includes(x.indexe))?.id_lead ;
 
       listeidleads.forEach(id_lead=>addEltHistory(id_lead,'leadgagne', `<div class='horoline1' > <span className=horobold'>Lead passé en ${jsonstatutscontrats[newstatus]?.toUppercase()}. </span> </div>` ) );
        await Promise.all( listidchangestatut.map((indexe) =>axios_contrats_updatecontrat({indexe,etat_contrat:newstatus})));        
        queryClient.invalidateQueries({queryKey: ['allcontrats',dates.date1,dates.date2]}) ;
        setListidchange([]) ;
        setShowpopupchangestatut(null) ; 
    }


    const recule = ()=>{setEtape(1)}
    const avance = ()=>{ etape===1? setEtape(2) : requalification() }

    const defineewstatut = (e)=>{e.target.value!=='Statut'  && setNewstatus(e.target.value) ;}

    return(<div  className="containergray">
               <div className="ecrangestionreassigner">
               <div className="cardresilitationclose" ><img src={croixclose}  alt="imgclose" onClick={()=> setShowpopupchangestatut(null) }  /></div>

                <div className="ecrangestionreassigner_titre center" >Changement de Statut</div>
                <Boulettes total={3} etape={etape} />
             { etape===1 ? <> 
                <div className="ecrangestionreassigner_titre left" >Quel statut voulez vous affecter à ces {listidchangestatut?.length||0} contrats ?</div>  

             <div className="ecrangestionreassigner_texte">Statuts des contrats</div>
                <select  className='selectcom' onChange={defineewstatut} >
                        <option className='selectcom_option' value={undefined} >Statut</option>
                        {Object.keys(jsonstatutscontrats)?.map((x,i)=><option key={i}  value={x} >{jsonstatutscontrats[x]}</option>)}
                 </select><br/><br/>
                <div className="ecrangestionreassigner_btns" >
                    <ButtonSimple  texte="Continuer" containerbouton='fullbutonX'  color='bouton_color_orange' size='bouton_size_normal' disable={newstatus===null} onclick={avance}  />
                </div></>:<>
                <div className="ecrangestionreassigner_titre center"  >Souhaitez-vous réellement requalifier ces {listidchangestatut?.length||0} leads à {newstatus} ?</div>
                <div  className="ecrangestionreassigner_texte center" >Cette opération est irréversible</div><br/><br/>
                <div className="ecrangestionreassigner_btns" >
                    <ButtonSimple  texte="Retour"  color='bouton_color_blancgris' size='bouton_size_normal' disable={newstatus===null} onclick={recule}  />
                    <ButtonSimple  texte="Confirmer"  color='bouton_color_orange' size='bouton_size_normal' disable={newstatus===null||newstatus==='Statut'} onclick={avance}  />
                </div></>}
               </div>
           </div>)
}


export default PopupChangeStatutContrat